import { buildModelManager } from "../builder.js";
const DefaultQuickChartEvaluationSelection = {
  __typename: true,
  id: true,
  agencyQaSnapshot: true,
  chartMetadata: true,
  chartText: { markdown: true, truncatedHTML: true },
  createdAt: true,
  createdById: true,
  emailMetadata: true,
  errorMessage: true,
  evaluationResult: true,
  evaluatorMetadata: true,
  findingsSummary: { markdown: true, truncatedHTML: true },
  forceCmsMedicalNecessityReview: true,
  forceTennesseeProtocolCheck: true,
  ingestionSource: true,
  institution: true,
  notificationStatus: true,
  originalFileId: true,
  overallStatus: true,
  qaChartId: true,
  qaWorkflowId: true,
  qualityTier: true,
  scopeSummary: true,
  sourceDocument: { url: true, mimeType: true, fileName: true },
  sourceEmail: true,
  sourceMessageId: true,
  sourceReference: true,
  sourceSubject: true,
  sourceSystem: true,
  sourceType: true,
  status: true,
  title: true,
  updatedAt: true,
  workflowBackboneStatus: true,
  workflowStage: true
};
const modelApiIdentifier = "quickChartEvaluation";
const pluralModelApiIdentifier = "quickChartEvaluations";
;
;
;
;
;
const operations = [
  {
    type: "findOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultQuickChartEvaluationSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultQuickChartEvaluationSelection,
    namespace: null
  },
  {
    type: "findMany",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultQuickChartEvaluationSelection,
    namespace: null
  },
  {
    type: "findFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultQuickChartEvaluationSelection,
    namespace: null
  },
  {
    type: "maybeFindFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultQuickChartEvaluationSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultQuickChartEvaluationSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultQuickChartEvaluationSelection,
    namespace: null
  },
  {
    type: "computedView",
    operationName: "view",
    functionName: "view",
    gqlFieldName: "quickChartEvaluationGellyView",
    namespace: null,
    variables: {
      query: { type: "String", required: true },
      args: { type: "JSONObject" }
    }
  }
];
const QuickChartEvaluationManager = buildModelManager(
  modelApiIdentifier,
  pluralModelApiIdentifier,
  DefaultQuickChartEvaluationSelection,
  operations
);
export {
  DefaultQuickChartEvaluationSelection,
  QuickChartEvaluationManager
};
//# sourceMappingURL=QuickChartEvaluation.js.map
